import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  LinearProgress,
} from "@mui/material";

export const CYCLeaderboard = () => {
  // Mock data for three different groups
  const group1Data = [
    { rank: 1, name: "John Doe", progress: 85 },
    { rank: 2, name: "Jane Smith", progress: 72 },
    { rank: 3, name: "Mike Johnson", progress: 65 },
  ];

  const group2Data = [
    { rank: 1, name: "Sarah Wilson", progress: 92 },
    { rank: 2, name: "David Brown", progress: 88 },
    { rank: 3, name: "Emma Davis", progress: 75 },
  ];

  const group3Data = [
    { rank: 1, name: "Alex Turner", progress: 95 },
    { rank: 2, name: "Lisa Anderson", progress: 90 },
    { rank: 3, name: "Chris Martin", progress: 82 },
  ];

  const LeaderboardGroup = ({
    title,
    data,
  }: {
    title: string;
    data: typeof group1Data;
  }) => {
    return (
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h2" gutterBottom>
          {title}
        </Typography>
        <TableContainer component={Paper} elevation={2}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Rank</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Progress</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((user) => (
                <TableRow key={user.rank}>
                  <TableCell>#{user.rank}</TableCell>
                  <TableCell>{user.name}</TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box sx={{ flexGrow: 1 }}>
                        <LinearProgress
                          variant="determinate"
                          value={user.progress}
                          sx={{
                            height: 8,
                            borderRadius: 4,
                            backgroundColor: "grey.200",
                            "& .MuiLinearProgress-bar": {
                              borderRadius: 4,
                            },
                          }}
                        />
                      </Box>
                      <Typography variant="body2" color="text.secondary">
                        {user.progress}%
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  return (
    <Box sx={{ maxWidth: "4xl", mx: "auto", p: 3 }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <LeaderboardGroup title="Group 1" data={group1Data} />
        <LeaderboardGroup title="Group 2" data={group2Data} />
        <LeaderboardGroup title="Group 3" data={group3Data} />
      </Box>
    </Box>
  );
};
